import styled from "styled-components";
import {Card, Checkbox} from "antd";

export const UploadWrapper = styled("div")`
  .upload__submit--btn {
    margin-top: 5px;
  }
`;
export const TopicsContainer = styled("div")`
  display: flex;
  margin-left: 10px;
`;
export const CheckboxWrapper = styled(Checkbox)`
 margin-right: 10px;
 margin-bottom:5px;
 .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #4A60F4;
    border-color: #4A60F4;
 }
`;
export const UploadListItem = styled(Card)`
  margin-top: 30px;
  .ant-card-body {
    padding: 5px;
    padding-left: 20;
    padding-right: 20;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .percent {
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    color: #7C82A7;
    padding-left: 10px;
    padding-top: 10px;
  }
  .dot {
    margin-left: 5px;
    margin-Right: 5px;
    line-height:0px;
    color: #4A60F4;
    font-size: 30px;
  }
`;
export const LoadingWrapper = styled.div`
  min-width: 100%;
  min-height: 100vh;
  background: #4f6ff4;
  text-align: center;
  position: fixed;
  position: fixed;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const LimitWrapper = styled.div`
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #7C82A7;
  margin-top: 20px;
  text-align: center;
`;
export const LodingInnerWrapper = styled.div``;
export const ProgressContent = styled.div`
  position: absolute;
  top: 120px;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 1;
  h2 {
    font-family: Lato;
    font-style: normal;
    font-weight: 600;
    font-size: 36px;
    line-height: 43px;
    color: #252525;
    margin-bottom: 10px;
  }
  p {
    font-family: Lato;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    color: #707070;
  }
  @media (max-width: 768px) {
    width: 120px;
    top: 10px;
    h2,
    p {
      display: none;
    }
  }
`;
export const ProgressWrapper = styled.div`
position: relative;
.ant-progress {
  width: 450px;
  @media (max-width: 768px) {
    width: 120px;
    top: 10px;
  }
}
.ant-progress-inner {
  border-radius: 20px;
  background: #D3DFFF;
  .ant-progress-bg {
    height: 60px !important;
    border-radius: 15px;
    background-image: -webkit-linear-gradient(
      -24deg
      , transparent 40%, rgba(92, 115, 251, 1) 17%, rgba(79,111, 244, 1) 63%, transparent 20%), -webkit-linear-gradient(top, rgba(79, 111, 244, 1), rgba(0, 0, 0, .25)), -webkit-linear-gradient(left, #4f6ff4, #4f6ff4);
          background-size: 34px 60px,100px 100px,100% 100%;
      }
  }
}
`;
export const LoadingContent = styled.div`
  h2 {
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 44.7539px;
    line-height: 54px;
    text-align: left;
    padding: 0;
    text-align: center;
    color: #ffffff;
    b {
      font-weight: 800;
    }
    img {
      position: relative;
      margin-left: 5px;
      top: 5px;
    }
    @media (max-width: 768px) {
      text-align: center;
    }
  }
  p {
    font-family: Lato;
    font-style: normal;
    font-weight: 300;
    font-size: 18px;
    padding: 0 66px;
    text-align: center;
    color: #ffffff;
  }
`;
export const LogoWrapper = styled.div`
  position: absolute;
  top: 60px;
`;
export const FormWrapper = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  form {
    width: 100%;
  }
  .ant-upload-drag {
    background: rgba(211, 214, 235, 0.15);
    border: none;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='5' ry='5' stroke='%23333' stroke-width='1' stroke-dasharray='11' stroke-dashoffset='84' stroke-linecap='square'/%3e%3c/svg%3e");
    border-radius: 5px;
    padding: 20px;
  }
  .ant-upload-list-item {
    background: #fff;
    position: realtive;
    display: flex;
    height: 100%;
    margin-top: 0px;
    padding: 25px;
    padding-left:0px;
    padding-top:5px;
    padding-bottom:10px;
    flex-direction: column;
    border-radius: 5px;
    .ant-upload-list-item-progress {
      padding-left: 10px;
      .ant-progress-outer {
        width: 100%;
        .ant-progress-inner {
          //   top: -32px;
        }
      }
    }
    .ant-upload-span {
      align-items: flex-start;
      .percentage {
        font-family: Lato;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        color: #7c82a7;
        position: absolute;
        left: 81px;
        bottom: 8px;
      }
    }
    .ant-progress-bg {
      background: #4f6ff4;
      height: 8px !important;
    }
    .ant-upload-list-item-name {
      font-family: Lato;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      padding-right: 70px;
      color: #000000;
    }
    .ant-upload-list-item-card-actions {
      position: absolute;
      top: 15px;
      right: -15px;
      button {
        display: inline !important;
        background: #ffeeee;
        color: #fff;
        border-radius: 100%;
        padding: 4px;
        height: 35px;
        width: 35px;
        text-align: center;
        line-height: 26px;
      }
    }
    &:hover {
      .ant-upload-list-item-info {
        background: transparent;
      }
    }
  }
  .ant-upload-list-item-progress {
    bottom: 0 !important;
    font-size: 14px;
    line-height: 0;
    position: absolute;
    top: 25px;
    width: 90%
  }
  .upload--text {
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    color: #7c82a7;
    span {
      font-weight: bold;
      font-size: 18px;
      color: #4a60f4;
    }
  }
  .upload--file {
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    color: #7c82a7;
  }
`;
export const Spacer = styled("div")`
  margin-top: 10px;
  margin-bottom: 20px;
  text-align: center;
  border-bottom: 1px solid #d3d6eb;
  position: relative;
  p {
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    position: relative;
    margin: 0 auto;
    background: white;
    padding: 0 36px;
    top: 9px;
    justify-content: center;
    display: inline;
  }
`;
